// @core/api/endpoints/document/update_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CategoryResponse,
  UpdateCategoryRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Update category
 * Updates a document category.
 */
export async function UpdateCategory(
  category_id: string,
  data: UpdateCategoryRequest,
  options?: RequestOptions
): Promise<CategoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-categories/:category_id`;
  requestPath = requestPath.replace(':category_id', encodeURIComponent(category_id));
  const requestOptions = options;
  return client.put<CategoryResponse>(requestPath, data, requestOptions);
}
